import { render } from "./batch-apply.vue?vue&type=template&id=b347ffe8&scoped=true"
import script from "./batch-apply.vue?vue&type=script&lang=js"
export * from "./batch-apply.vue?vue&type=script&lang=js"

import "./batch-apply.vue?vue&type=style&index=0&id=b347ffe8&lang=less&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b347ffe8"]])

export default __exports__